import { Chip, Paper, Popover, type SxProps } from '@mui/material'
import { type FC, type MouseEvent, type ReactNode, useCallback, useState } from 'react'

type Props = {
  icon: ReactNode
  children: ReactNode
  sx?: SxProps
}

export const IconPopover: FC<Props> = ({ icon, children, sx }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const handlePopoverOpen = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      setAnchorEl(e.currentTarget)
    },
    [setAnchorEl],
  )
  const handlePopoverClose = useCallback(() => {
    setAnchorEl(null)
  }, [setAnchorEl])
  const open = Boolean(anchorEl)

  return (
    <>
      <Chip
        label={icon}
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        sx={{ cursor: 'pointer', ...(sx ?? {}) }}
      />
      <Popover
        id="turnOffInfo"
        open={open}
        sx={{
          pointerEvents: 'none',
        }}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        onClose={handlePopoverClose}
        disableAutoFocus
        disableEnforceFocus
        disableRestoreFocus
      >
        <Paper sx={{ p: 1 }}>{children}</Paper>
      </Popover>
    </>
  )
}
